import { Table, TableBody, TableCell, TableRow } from "randmarcomps";
import React from "react";
import { FormattedNumber } from "react-intl";
import CurrencyUtils from "./CurrencyUtils";

interface IProps {
  subTotal?: number;
  SubTotal?: number;
  taxAmount1?: number;
  TaxAmount1?: number;
  taxAmount2?: number;
  TaxAmount2?: number;
  total?: number;
  Total?: number;
}

const TotalTable: React.FC<IProps> = ({ subTotal, SubTotal, taxAmount1, TaxAmount1, taxAmount2, TaxAmount2, total, Total }) => {
  const finalSubTotal = subTotal ?? SubTotal ?? 0;
  const finalTaxAmount1 = taxAmount1 ?? TaxAmount1 ?? 0;
  const finalTaxAmount2 = taxAmount2 ?? TaxAmount2 ?? 0;
  const finalTotal = total ?? Total ?? 0;

  return (
    <div className="rounded-lg border bg-white overflow-hidden">
      <Table>
        <TableBody>
          <TableRow>
            <TableCell className="py-3 px-4 font-medium text-gray-600">Sub Total</TableCell>
            <TableCell className="py-3 px-4 text-right font-mono">
              <FormattedNumber value={finalSubTotal} {...CurrencyUtils.format} />
            </TableCell>
          </TableRow>
          {finalTaxAmount1 !== 0 && (
            <TableRow>
              <TableCell className="py-3 px-4 font-medium text-gray-600">HST/GST</TableCell>
              <TableCell className="py-3 px-4 text-right font-mono">
                <FormattedNumber value={finalTaxAmount1} {...CurrencyUtils.format} />
              </TableCell>
            </TableRow>
          )}
          {finalTaxAmount2 !== 0 && (
            <TableRow>
              <TableCell className="py-3 px-4 font-medium text-gray-600">PST</TableCell>
              <TableCell className="py-3 px-4 text-right font-mono">
                <FormattedNumber value={finalTaxAmount2} {...CurrencyUtils.format} />
              </TableCell>
            </TableRow>
          )}
          <TableRow className="border-t bg-slate-50">
            <TableCell className="py-3 px-4 font-semibold">Total</TableCell>
            <TableCell className="py-3 px-4 text-right font-semibold font-mono">
              <FormattedNumber value={finalTotal} {...CurrencyUtils.format} />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  );
};

export default TotalTable;
